'use strict';

function CnQuestionnaireTextAreaController($scope, $timeout) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.DEBOUNCE_TIME = 1000;

  function $onInit() {
    vm.head = vm.head || '';
    vm.rows = vm.rows || 4;
    vm.error = vm.error === true || false;
    vm.locked = vm.locked === true || false;
    if (vm.employeeAnswer && vm.managerAnswer) {
      vm.commonAnswer = vm.employeeAnswer + '\n' + vm.managerAnswer;
    }
    $scope.$watch(function () {
      return vm.ngModel.$modelValue;
    }, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        debounceSave();
      }
    });
    vm.ngModel.$render = $render;
  }

  function $render() {
    vm.text = vm.ngModel.$modelValue || vm.commonAnswer;
    vm.ngModel.$setViewValue(vm.text);
  }

  var debounceSave = debounce(function () {
    vm.autosaveFunc();
  }, vm.DEBOUNCE_TIME);

  function debounce(func, wait) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        func.apply(context, args);
      };
      $timeout.cancel(timeout);
      timeout = $timeout(later, wait);
    };
  }
}

CnQuestionnaireTextAreaController.$inject = ['$scope', '$timeout'];
module.exports = CnQuestionnaireTextAreaController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-text-area/cn-questionnaire-text-area.controller.js
 ** module id = 100
 ** module chunks = 0
 **/